// src/pages/ProductDetails.jsx
/* eslint-disable */
import React, { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { styled } from "@mui/material/styles";
import {
  Grid,
  Paper,
  Typography,
  ButtonBase,
  IconButton,
  Rating,
  Button,
  Box,
} from "@mui/material";
import {
  Add as AddIcon,
  Remove as RemoveIcon,
  Description as DescriptionIcon,
  Language as LanguageIcon,
  Business as BusinessIcon,
  Print as PrintIcon,
  Height as HeightIcon,
  FavoriteBorder as FavoriteBorderIcon,
} from "@mui/icons-material";
import CheckDelivery from "../components/CheckDelivery";
import BookDetailsTabs from "../components/BookDetailsTabs";
import { useDispatch, useSelector } from "react-redux";
import { addItemToCart } from "../redux/cartSlice";
import { addToWishlist, removeFromWishlist } from "../redux/wishlistSlice"; // Import actions
import productsArray from "../jsons/products.json";
import "../styles/ImagePreview.css";

const Img = styled("img")({
  maxWidth: "100%",
  maxHeight: "100%",
  objectFit: "contain",
});

const HoveredImage = styled("div")({
  position: "absolute",
  width: "100px",
  height: "100px",
  borderRadius: "50%",
  boxShadow: "0 0 0 3px rgba(0, 0, 0, 0.5)",
  pointerEvents: "none",
  visibility: "hidden",
  backgroundImage: 'url("")',
  backgroundSize: "cover",
  zIndex: 1000,
  transition: "opacity 0.3s ease",
  opacity: 0,
});

const ProductDetails = () => {
  const { productId } = useParams();
  const product = productsArray.find((p) => p.id === parseInt(productId));

  const [mainImage, setMainImage] = useState(product ? product.imgSrc : "");
  const [quantity, setQuantity] = useState(1);
  const dispatch = useDispatch();
  const wishlistItems = useSelector((state) => state.wishlist.wishlist); // Access wishlist items from state

  if (!product) {
    return <Typography variant="h5">Product not found</Typography>;
  }

  const increaseQuantity = () => {
    setQuantity((prevQuantity) => prevQuantity + 1);
  };

  const decreaseQuantity = () => {
    if (quantity > 1) {
      setQuantity((prevQuantity) => prevQuantity - 1);
    }
  };

  const miniImages = [
    "https://m.media-amazon.com/images/I/71wP18MWVUL._SL1500_.jpg",
    "https://m.media-amazon.com/images/I/61K0QVReUML._SY425_.jpg",
    "https://m.media-amazon.com/images/I/71pd1VdGjFL._SY425_.jpg",
    // Add more URLs as needed
  ];

  const handleThumbnailClick = (imageSrc) => {
    setMainImage(imageSrc);
  };

  const handleThumbnailKeyPress = (event, image) => {
    if (event.key === "Enter") {
      setMainImage(image);
    }
  };

  const showHoveredImage = (event) => {
    const hoveredImage = document.getElementById("hoveredImage");
    if (hoveredImage) {
      hoveredImage.style.visibility = "visible";
      hoveredImage.style.opacity = 1;

      const rect = event.target.getBoundingClientRect();
      const x = event.clientX - rect.left - 25; // Adjust 25 to half the size of the enlarged area
      const y = event.clientY - rect.top - 25; // Adjust 25 to half the size of the enlarged area

      hoveredImage.style.transform = `translate(${x}px, ${y}px)`;
      hoveredImage.style.backgroundImage = `url(${mainImage})`;
    }
  };

  const hideHoveredImage = () => {
    const hoveredImage = document.getElementById("hoveredImage");
    if (hoveredImage) {
      hoveredImage.style.opacity = 0;
      hoveredImage.style.visibility = "hidden";
    }
  };

  const addToWishlistHandler = () => {
    if (!isInWishlist(product.id)) {
      dispatch(addToWishlist(product)); // Dispatch action to add item to wishlist
    } else {
      dispatch(removeFromWishlist(product.id)); // Dispatch action to remove item from wishlist
    }
  };

  const isInWishlist = (productId) => {
    return wishlistItems.some((item) => item.id === productId);
  };

  const description =
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed blandit orci nec dui aliquet, vel gravida eros dictum. Mauris efficitur tellus sit amet massa dignissim, eu fermentum libero consectetur.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed blandit orci nec dui aliquet, vel gravida eros dictum. Mauris efficitur tellus sit amet massa dignissim, eu fermentum libero consectetur.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed blandit orci nec dui aliquet, vel gravida eros dictum. Mauris efficitur tellus sit amet massa dignissim, eu fermentum libero consectetur.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed blandit orci nec dui aliquet, vel gravida eros dictum. Mauris efficitur tellus sit amet massa dignissim, eu fermentum libero consectetur.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed blandit orci nec dui aliquet, vel gravida eros dictum. Mauris efficitur tellus sit amet massa dignissim, eu fermentum libero consectetur.";

  const authorDetails =
    "John Doe is a renowned author known for his works in the field of computer science and data analytics.John Doe is a renowned author known for his works in the field of computer science and data analytics.John Doe is a renowned author known for his works in the field of computer science and data analytics.John Doe is a renowned author known for his works in the field of computer science and data analytics.John Doe is a renowned author known for his works in the field of computer science and data analytics.John Doe is a renowned author known for his works in the field of computer science and data analytics.John Doe is a renowned author known for his works in the field of computer science and data analytics.John Doe is a renowned author known for his works in the field of computer science and data analytics.";

  return (
    <Paper
      sx={{
        p: 2,
        margin: "auto",
        maxWidth: "100%",
        flexGrow: 1,
        backgroundColor: (theme) =>
          theme.palette.mode === "dark" ? "#1A2027" : "#fff",
        marginBottom: "20px",
      }}
    >
      <Grid container spacing={2} sx={{ display: "flex" }}>
        <Grid item className="acImageContainer">
          <Grid className="mainImageContainer">
            <ButtonBase
              onMouseMove={showHoveredImage}
              onMouseLeave={hideHoveredImage}
              onClick={() => handleThumbnailClick(product.imgSrc)}
              onKeyPress={(event) =>
                handleThumbnailKeyPress(event, product.imgSrc)
              }
              sx={{ width: 387, height: 387 }}
            >
              {mainImage && <Img src={mainImage} alt="Main" />}
              <HoveredImage id="hoveredImage" />
            </ButtonBase>
            <Grid item></Grid>
          </Grid>
          <Grid className="miniImageContainer">
            {miniImages.map((imageSrc, index) => (
              <div
                key={index}
                className="miniImage boxShadow1"
                role="button"
                onClick={() => handleThumbnailClick(imageSrc)}
                onKeyPress={(event) => {
                  if (event.key === "Enter") {
                    handleThumbnailClick(imageSrc);
                  }
                }}
                tabIndex={0}
              >
                <img
                  className="miniImg1 miniImg"
                  src={imageSrc}
                  alt={`Mini ${index}`}
                />
              </div>
            ))}
          </Grid>
        </Grid>
        <Typography
          variant="subtitle1"
          component="div"
          sx={{ paddingTop: "10px" }}
        >
          <IconButton
            sx={{ backgroundColor: isInWishlist(product.id) ? "#ffffff" : "transparent" }}
            onClick={addToWishlistHandler}
            aria-label="Add to Wishlist"
          >
            <FavoriteBorderIcon color={isInWishlist(product.id) ? "primary" : "inherit"} />
          </IconButton>
        </Typography>
        <Grid item xs={12} sm container sx={{ gap: "10px" }}>
          <Grid item container spacing={2}>
            <Grid item xs>
              <Typography
                variant="h4"
                sx={{ fontSize: "24px", marginBottom: "10px" }}
              >
                {product.title}
              </Typography>
              <Typography variant="body1">by {product.author}</Typography>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: "10px",
                }}
              >
                <Rating
                  name="size-small"
                  value={product.rating}
                  size="small"
                  readOnly
                />
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ marginLeft: "5px" }}
                >
                  {product.rating}
                </Typography>
              </div>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  alignItems: "center",
                  marginTop: "8px",
                }}
              >
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ fontSize: "18px", fontWeight: "700" }}
                >
                  ₹{product.price}
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ fontSize: "16px", textDecoration: "line-through" }}
                >
                  ₹{product.oldPrice}
                </Typography>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: "12px",
                }}
              >
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ marginRight: "10px" }}
                >
                  Quantity:
                </Typography>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={decreaseQuantity}
                  >
                    <RemoveIcon />
                  </Button>
                  <Typography variant="body2">{quantity}</Typography>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={increaseQuantity}
                  >
                    <AddIcon />
                  </Button>
                </div>
              </div>
              <Grid item>
                <Grid container spacing={1} alignItems="center" sx={{ mt: 2, mb: 2 }}>
                  <Grid item>
                    <Paper
                      variant="outlined"
                      sx={{
                        p: 1,
                        minWidth: 120,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: '#f0f0f0'
                      }}
                    >
                      <Typography>ISBN</Typography>
                      <DescriptionIcon sx={{ mr: 1 }} />
                      <Typography variant="body2" color="text.secondary">
                        {product.isbn}
                      </Typography>
                    </Paper>
                  </Grid>
                  <Grid item>
                    <Paper
                      variant="outlined"
                      sx={{
                        p: 1,
                        minWidth: 120,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: '#f0f0f0'
                      }}
                    >
                      <Typography>Language</Typography>
                      <LanguageIcon sx={{ mr: 1 }} />
                      <Typography variant="body2" color="text.secondary">
                        {product.language}
                      </Typography>
                    </Paper>
                  </Grid>
                  <Grid item>
                    <Paper
                      variant="outlined"
                      sx={{
                        p: 1,
                        minWidth: 120,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: '#f0f0f0'
                      }}
                    >
                      <Typography>Publisher</Typography>
                      <BusinessIcon sx={{ mr: 1 }} />
                      <Typography variant="body2" color="text.secondary">
                        {product.publisher}
                      </Typography>
                    </Paper>
                  </Grid>
                  <Grid item>
                    <Paper
                      variant="outlined"
                      sx={{
                        p: 1,
                        minWidth: 120,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: '#f0f0f0'
                      }}
                    >
                      <Typography>Print Length</Typography>
                      <PrintIcon sx={{ mr: 1 }} />
                      <Typography variant="body2" color="text.secondary">
                        {product.printLength}
                      </Typography>
                    </Paper>
                  </Grid>
                  <Grid item>
                    <Paper
                      variant="outlined"
                      sx={{
                        p: 1,
                        minWidth: 120,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: '#f0f0f0'
                      }}
                    >
                      <Typography>Dimensions</Typography>
                      <HeightIcon sx={{ mr: 1 }} />
                      <Typography variant="body2" color="text.secondary">
                        {product.dimensions}
                      </Typography>
                    </Paper>
                  </Grid>
                </Grid>
              </Grid>
              <Button
                onClick={() => {
                  dispatch(addItemToCart({ ...product, quantity }));
                }}
                variant="contained"
                color="primary"
                sx={{ marginTop: "20px" }}
              >
                Add to Cart
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <div className="descriptionContainer">
        <BookDetailsTabs
          tabs={[
            {
              tabButton: "Description",
              tabIcon: DescriptionIcon,
              tabContent: (
                <Box>
                  <Typography variant="body2">{description}</Typography>
                </Box>
              ),
            },
            {
              tabButton: "Author Details",
              tabIcon: LanguageIcon,
              tabContent: (
                <Box>
                  <Typography variant="body2">{authorDetails}</Typography>
                </Box>
              ),
            },
            {
              tabButton: "Specifications",
              tabIcon: BusinessIcon,
              tabContent: (
                <Box>
                  <CheckDelivery />
                </Box>
              ),
            },
            {
              tabButton: "Print",
              tabIcon: PrintIcon,
              tabContent: (
                <Box>
                  <HeightIcon />
                </Box>
              ),
            },
          ]}
        />
      </div>
    </Paper>
  );
};

export default ProductDetails;

